import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/main.css';

const Header = () => {
  const location = useLocation();
  const [isMenuOpen, setMenuOpen] = useState(false);

  // Google Analytics setup
  useEffect(() => {
    // Load Google Analytics script
    const loadGoogleAnalytics = () => {
      // Check if script already exists
      if (document.querySelector('script[src*="googletagmanager.com"]')) {
        return;
      }

      // First script - gtag.js
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-98MYNML64W';
      script1.onload = () => {
        // Initialize dataLayer and gtag
        window.dataLayer = window.dataLayer || [];
        function gtag(){window.dataLayer.push(arguments);}
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', 'G-98MYNML64W');
        
        // Track initial page view
        gtag('event', 'page_view', {
          page_title: document.title,
          page_location: window.location.href,
          page_path: location.pathname,
        });
      };
      document.head.appendChild(script1);
    };

    // Only run on client side
    if (typeof window !== 'undefined') {
      loadGoogleAnalytics();
    }

    // Cleanup function
    return () => {
      // Cleanup is minimal since we want scripts to persist
      // They'll be removed when component unmounts if needed
    };
  }, []); // Empty dependency array - runs once on mount

  // Track page views when location changes
  useEffect(() => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: document.title,
        page_location: window.location.href,
        page_path: location.pathname,
      });
    }
  }, [location.pathname]);

  return (
    <header className="header">
      <div className="container">
        <div className="logo">
          <Link to="/">
            <img 
              src="/logo.png" 
              alt="ebookkeepings Logo" 
              height="40" 
              loading="lazy" 
            />
          </Link>
        </div>
        <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
          <Link 
            to="/" 
            className={location.pathname === '/' ? 'active' : ''}
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className={location.pathname === '/about' ? 'active' : ''}
          >
            About
          </Link>
          <Link 
            to="/listing" 
            className={location.pathname === '/listing' ? 'active' : ''}
          >
            Bookkeepers
          </Link>
          <Link to="/register" className="">
            Register
          </Link>
          <Link 
            to="/contact" 
            className={location.pathname === '/contact' ? 'active' : ''}
          >
            Contact
          </Link>
        </nav>
        <button 
          className="menu-toggle" 
          onClick={() => setMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <svg width="30" height="30" fill="none" stroke="#ffffff" strokeWidth="2">
            <path d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>
    </header>
  );
};

export default Header;